import { Badge, BadgeSize } from "shared/components";
import { HugeiconsIcon } from "@hugeicons/react";
import { mapIncomeSourceStatus } from "../helpers";
import { CombinedIncome } from "../types/income";
import { cx } from "shared/utils";
import { INCOME_SOURCE_BADGE_STATUSES_MAP } from "../constants";

export const IncomeSourceStatusBadge = ({
  income,
  shouldIgnoreIcon = false
}: {
  income: CombinedIncome;
  shouldIgnoreIcon?: boolean;
}) => {
  const { status } = mapIncomeSourceStatus(income);
  const config = INCOME_SOURCE_BADGE_STATUSES_MAP[status || "Accepted"];

  return (
    <Badge
      variant={config.variant}
      size={BadgeSize.SM}
      className="items-center"
      leftElement={
        shouldIgnoreIcon ? undefined : (
          <HugeiconsIcon
            icon={config.icon}
            size={config.iconSize}
            className={cx("stroke-none", config.iconColor)}
          />
        )
      }
    >
      {status === "Rejected" ? "Unverified" : config.title}
    </Badge>
  );
};
